module.exports = __webpack_public_path__ + "img/1369920992.a878cca3.jpg";